// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"_7523bf9","linkIcon":"_d87a0e5","active":"_ee60c32"};